<div *ngIf="showFooter$ | async; then fullFooter; else emptyFooter"></div>
<ng-template #fullFooter>
  <footer class="footer">
    <app-wrapper maxWidth="1140px">
      <div class="footer__links">
        <div class="footer__section">
          <p class="footer__section-header">Resolve</p>
          <ul>
            <li>
              <a [routerLink]="['/rdata-aggregates']">rData Aggregates</a>
            </li>
            <li>
              <a [routerLink]="['/rdata-records']">rData Records</a>
            </li>
          </ul>
        </div>
        <div class="footer__section">
          <p class="footer__section-header">Contact Us</p>
          <ul>
            <li>
              <a href="mailto:info@resolve.com"> info&#64;resolve.com </a>
            </li>
            <li>
              <a href="tel:8777583318"> 1-877-758-3318 </a>
            </li>
            <li class="footer__social">
              <a
                class="footer__social-icon"
                href="https://www.instagram.com/resolveteam/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/icons/instagram.svg"
                  alt="Instagram"
                  width="30"
                  height="30"
                />
              </a>
              <a
                class="footer__social-icon"
                href="https://www.facebook.com/resolvephysicianagency/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/icons/facebook.svg"
                  alt="Facebook"
                  width="30"
                  height="30"
                />
              </a>
              <a
                class="footer__social-icon"
                href="https://www.linkedin.com/company/resolve-physician-agency/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/icons/linkedin.svg"
                  alt="LinkedIn"
                  width="30"
                  height="30"
                />
              </a>
              <a
                class="footer__social-icon"
                href="https://twitter.com/ResolveAgents"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/icons/twitter.svg"
                  alt="Twitter"
                  width="30"
                  height="30"
                />
              </a>
            </li>
          </ul>
        </div>

        <div class="footer__legal">
          <div class="footer__legal-pages">
            <ul>
              <li>
                <a href="https://www.resolve.com/privacy" target="_blank">Privacy Policy</a>
              </li>
              <li>
                <a class="footer__no-caps" href="https://www.resolve.com/terms" target="_blank"
                  >Terms of Use</a
                >
              </li>
            </ul>
            <ul>
              <li>
                <a href="https://www.resolve.com/dmca" target="_blank">DMCA</a>
              </li>
              <li>
                <a href="https://www.resolve.com/disclaimer" target="_blank">Disclaimer</a>
              </li>
            </ul>
          </div>
          <p class="copyright">
            &copy; Resolve {{ currentYear }} All Rights Reserved
          </p>
        </div>
      </div>
    </app-wrapper>
  </footer>
</ng-template>
<ng-template #emptyFooter></ng-template>
